<template>
    <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="inDate"
    transition="scale-transition"
    :offset-y="true"
    min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
            v-model="inDate" :dense="dense" :outlined="outlined"
            label="Chọn ngày"
            :prepend-icon="icon"
            readonly v-bind="attrs" v-on="on" hide-details
            :style="`max-width: ${width}`"
            ></v-text-field>
        </template>
        <v-date-picker v-model="inDate" no-title scrollable :range="range" locale="vi" color="teal darken-4" :readonly="readonly">
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="menu = false" >
                Cancel
            </v-btn>
            <v-btn text color="orange"
            @click="apply" >
            OK
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>
<script>
import * as moment from "moment/moment";
export default {
    name: "DatePickerRange",
    props: {
        value: {        // Type of the prop, e.g., String, Number, Boolean, Object, Array
        },
        icon: {
            type: String,         // Type of the prop, e.g., String, Number, Boolean, Object, Array
        },
        dense: {
            type: Boolean,         // Type of the prop, e.g., String, Number, Boolean, Object, Array
        },
        outlined: {
            type: Boolean,         // Type of the prop, e.g., String, Number, Boolean, Object, Array
        },
        readonly: {
            type: Boolean,         // Type of the prop, e.g., String, Number, Boolean, Object, Array
        },
        range: {
            type: Boolean,         // Type of the prop, e.g., String, Number, Boolean, Object, Array
            default: true
        },
        width: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            menu:false,
            inDate: [],
        }
    },
    methods:{
        apply(){
            this.$refs.menu.save(this.inDate);
            this.$emit("input", this.inDate);
        }
    },
    created(){
        this.inDate = this.value
    }
}
</script>